export const AUTH_LOGOUT_EVENT = 'app:logout';
export const AUTH_FORCE_LOGOUT_CHANNEL = 'hr-portal-auth';

export const getLoginRedirectPath = (role) => (role === 'admin' ? '/admin' : '/');

/** Notify Header to close WebSocket, then clear session. Returns login redirect path. */
export const clearSession = () => {
    const role = localStorage.getItem('role');
    window.dispatchEvent(new CustomEvent(AUTH_LOGOUT_EVENT));
    localStorage.clear();
    return getLoginRedirectPath(role);
};

export const shouldForceLogoutCurrentUser = (employeeId) => {
    const currentUserId = localStorage.getItem('id');
    return Boolean(currentUserId && employeeId && currentUserId === employeeId);
};

/** Log out in this tab and redirect to login. */
export const performLogout = (navigate) => {
    const redirectPath = clearSession();
    if (navigate) {
        navigate(redirectPath, { replace: true });
    } else {
        window.location.replace(redirectPath);
    }
};

/**
 * Tell other tabs/windows to log out if they belong to this employee (same browser only).
 */
export const broadcastEmployeeForceLogout = (employeeId) => {
    if (!employeeId || typeof BroadcastChannel === 'undefined') return;
    try {
        const channel = new BroadcastChannel(AUTH_FORCE_LOGOUT_CHANNEL);
        channel.postMessage({ type: 'FORCE_LOGOUT', employeeId });
        channel.close();
    } catch (error) {
        console.warn('BroadcastChannel unavailable for employee logout:', error);
    }
};
